import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "blueprint-courses",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "blueprint-courses" */ "./components"),
      import(
        /* webpackChunkName: "blueprint-courses" */ "LearningCourses/modules/LearningCoursesModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;

      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "learningCourses",
        reducer,
      });

      return component;
    })
  ),
});
